import { Asset, Assignment } from 'able-lib'

export interface AssignmentStateInterface {
  assignments: Array<Assignment>;
  studentResponses: [];
  scores: [];
  answerAttachments: Array<Asset>;
  unansweredAssignmentsCount: number;
}

export default function (): AssignmentStateInterface {
  return {
    assignments: [],
    studentResponses: [],
    scores: [],
    answerAttachments: [],
    unansweredAssignmentsCount: 0
  }
}
